import script from "./CompleteProfileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteProfileModal.vue?vue&type=script&setup=true&lang=js"

import "./CompleteProfileModal.vue?vue&type=style&index=0&id=1ece161b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ece161b"]])

export default __exports__